<template>
  <div class="component-subCateView" ref="subCateViewEl">
    <!-- tab菜单 -->
    <div class="tab-wrap">
      <div class="tab-list" :style="{right: `${subCateList.length>5 ? '0.8rem' : '0'}`}">
        <md-tab-bar
          v-model="selectSubCateId"
          :items="subCateList"
          :maxLength="5"
          :ink-length="70"
          @change="handleChangeTab"
        />
      </div>
      <div class="btn-down" v-if="subCateList.length>5" @click="handleClickShowAllTab()">
        <img class="ic-arrow" :src="downIcon" />
      </div>
    </div>
    <div
      class="select-popup"
      v-if="showSelectPopup"
      :style="{top: `${popupTop}px`}"
      v-clickoutside="handleClickOutSide"
    >
      <div class="select-popup-mask" @click="showSelectPopup=false"></div>
      <div class="select-head">
        <span class="select-title">全部分类</span>
        <div class="shadow"></div>
        <div class="btn-up" @click="handleClickShowAllTab()">
          <img class="ic-arrow" :src="upIcon" />
        </div>
      </div>
      <!-- 下拉菜单 -->
      <ul class="select-list">
        <li
          class="select-item"
          :class="{active: selectSubCateId === item.name}"
          v-for="(item, index) in subCateList"
          :key="item.name"
          @click="handleClickSelectItem(item, index)"
        >
          {{item.label}}
          <span class="active-ink" v-show="selectSubCateId === item.name"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { TabBar } from 'mand-mobile'
import Clickoutside from '@/utils/clickoutside'
export default {
  name: 'subCateView',
  directives: { Clickoutside },
  components: {
    [TabBar.name]: TabBar,
  },
  props: {
    subCateList: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  data() {
    return {
      upIcon: require('../assets/ic_up.png'),
      downIcon: require('../assets/ic_down.png'),
      showSelectPopup: false, // 显示选择三级分类的下拉列表
      popupTop: 0, // 下拉列表距离顶部的距离
      selectSubCateId: -1, // 已选择的三级分类ID
    }
  },
  methods: {
    /**
     * 初始化tab
     */
    init(cateId) {
      this.showSelectPopup = false
      this.selectSubCateId = cateId
    },
    /**
     * 手动切换tab
     */
    handleChangeTab(item, index, prevIndex) {
      this.setSelctedCateId(item.name, index)
    },
    /**
     * 点击下拉菜单item
     */
    handleClickSelectItem(item, index) {
      this.showSelectPopup = false
      this.setSelctedCateId(item.name, index)
    },
    setSelctedCateId(cateId, index) {
      if (this.selectSubCateId !== cateId) {
        this.selectSubCateId = cateId
        this.$emit('change', this.selectSubCateId, index)
      }
    },
    /**
     * 点击显示全部tab
     */
    handleClickShowAllTab() {
      if (!this.showSelectPopup) {
        this.setPopupPosition()
        this.showSelectPopup = true
      } else {
        this.showSelectPopup = false
      }
    },
    /**
     * 设置popup位置
     */
    setPopupPosition() {
      const node = this.$refs['subCateViewEl']
      if (node) {
        this.popupTop = node.offsetTop
      }
    },
    /**
     * 点击外部区域
     */
    handleClickOutSide() {
      this.showSelectPopup = false
    },
  },
}
</script>

<style  lang="scss" scoped>
.component-subCateView {
  .tab-wrap {
    position: relative;
    height: 0.72rem;
    background: #fff;
    border-top: 0.02rem solid #eee;
    .tab-list {
      position: absolute;
      top: 0;
      left: 0;
      right: 0.8rem;
      height: 0.7rem;
      .md-tab-bar {
        padding-left: 0.1rem;
        padding-right: 0;
      }
    }
    .btn-down {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 0;
      top: 0;
      height: 0.7rem;
      width: 0.8rem;
      .ic-arrow {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .select-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    pointer-events: none;
    z-index: 1000;
    .select-popup-mask {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      pointer-events: auto;
      z-index: 1;
      background-color: rgba(37, 38, 45, 0.7);
    }
    .select-head {
      position: absolute;
      display: flex;
      align-items: center;
      pointer-events: auto;
      top: 0;
      right: 0;
      left: 0;
      background: #fff;
      z-index: 2;
      height: 0.72rem;
      border-top: 0.02rem solid #eee;
      padding-left: 0.3rem;
      .select-title {
        font-size: 0.3rem;
        color: #999;
      }
      .shadow {
        position: absolute;
        left: auto;
        right: 0.8rem;
        top: 0.15rem;
        height: 0.4rem;
        width: 0.14rem;
        transform: rotate(180deg);
        overflow: hidden;
        &:after {
          content: '';
          display: block;
          position: absolute;
          left: -0.14rem;
          top: 50%;
          width: 0.14rem;
          margin-top: -0.4rem;
          height: 0.8rem;
          border-radius: 50%;
          box-shadow: -1px 0 0.12rem 0 rgba(0, 0, 0, 0.2);
        }
      }
      .btn-up {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        right: 0;
        top: 0;
        height: 0.7rem;
        width: 0.8rem;
        .ic-arrow {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
    }
    .select-list {
      position: absolute;
      pointer-events: auto;
      top: 0.72rem;
      right: 0;
      left: 0;
      background: #fff;
      z-index: 2;
      overflow: auto;
      padding: 0 0.1rem 0.2rem;
      .select-item {
        position: relative;
        height: 0.6rem;
        line-height: 0.6rem;
        text-align: center;
        margin-bottom: 0.2rem;
        float: left;
        width: 25%;
        font-size: 0.28rem;
        font-weight: 500;
        color: #666;
        &.active {
          color: #ff1e32;
          font-weight: 600;
        }
        .active-ink {
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 40%;
          margin-left: -20%;
          display: block;
          height: 0.04rem;
          background-color: #ff1e32;
          transition: all 300ms;
        }
      }
    }
  }
}
</style>